import styled from 'styled-components'

import { FlexRow, Image, Form, Icon, Help } from '..'

interface ItemProps {
  className?: string
  checked?: boolean
  active?: boolean
  disabled?: boolean
  title: string
  image?: string
  help?: string
  style?: React.CSSProperties
  checkable?: boolean
  imageDisabled?: boolean
  onClick: (e: React.MouseEvent, data: { checked?: boolean }) => void
}

const Item = styled(
  ({
    className,
    checked,
    active,
    disabled,
    title,
    image,
    help,
    style,
    checkable,
    imageDisabled,
    onClick,
  }: ItemProps) => (
    <FlexRow
      noMargin
      className={className}
      alignItems="center"
      style={style}
      onClick={!disabled ? onClick : undefined}>
      <FlexRow.Section
        flex={6}
        style={{ width: active ? 'calc(100% - 23px)' : '100%' }}>
        {!imageDisabled && image && <Image avatar src={image} />}
        <span title={title}>{title}</span>
      </FlexRow.Section>
      {(active || help) && (
        <FlexRow.Section justifyContent="flex-end">
          {help ? (
            <Help content={help} color={active ? 'white' : 'blue'} />
          ) : checkable ? (
            <Form.Checkbox
              checked={checked}
              onClick={(e, { checked }) => {
                e.stopPropagation()
                onClick(e, { checked })
              }}
              style={{
                position: 'relative',
                top: '4px',
              }}
            />
          ) : (
            <Icon button name="icon-checkmark" size="large" color="white" />
          )}
        </FlexRow.Section>
      )}
    </FlexRow>
  ),
)`
  padding: 0.5em;
  cursor: ${props => (!props.disabled ? 'pointer' : 'default')};
  font-size: 13px;
  font-weight: ${props => (props.active ? 'bold' : 'initial')};
  background: ${props => (props.active ? '#21ba45' : 'none')};
  color: ${props => (props.active ? '#fff' : 'initial')};
  margin-top: -3px;

  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    top: 3px;
  }

  .image {
    height: 1.5em !important;
    width: 1.5em !important;
    margin-right: 0.5em !important;
    object-fit: cover;
  }

  ${props =>
    !props.disabled &&
    `
      :hover {
        background: ${props.active ? '#1eab3f' : '#efefef'};
      }
  `};
`

export default Item
